import * as React from 'react';

var _path, _path2, _path3, _path4, _rect, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRedeeminline = function SvgRedeeminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.546 39.174c1.609.295 3.622-.505 5.097-1.103 2.32-.94 3.925-2.637 6.032-3.871 2.72-1.6 6.773-1.534 9.83-1.812 3.754-.34 10.843-2.08 10.843-7.03-.156-.067-.3-.202-.468-.202-10.72.034-20.943 0-31.414.253-.35 3.69-.139 6.461-.202 10.164-.021 1.116-.215 3.134-.06 4.237.17 1.184-.757-.838.342-.64v.004Z",
    fill: "#00B0B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.264 41.507V26.053c0-.476.387-.864.863-.864h30.938c.476 0 .864.388.864.864v15.454a.865.865 0 0 1-.864.864H25.497",
    stroke: "#001E62",
    strokeWidth: 0.842,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.364 23.067v-2.595c0-.476.388-.864.864-.864h30.938c.476 0 .863.388.863.864v15.454a.865.865 0 0 1-.863.864h-2.11",
    stroke: "#001E62",
    strokeWidth: 0.842,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.968 35.254h.49c-.023.306-.137.546-.343.718-.189.161-.435.242-.738.242-.4 0-.708-.145-.92-.434-.168-.23-.264-.533-.288-.91h-.435l.147-.395h.288v-.353h-.384l.147-.395h.237c.007-.42.121-.76.344-1.016.215-.246.504-.369.864-.369.33 0 .595.096.794.288.178.176.278.401.298.678h-.506a.555.555 0 0 0-.212-.38.601.601 0 0 0-.374-.11c-.246 0-.428.099-.546.298-.09.155-.143.359-.157.611h1.355l-.146.395h-1.209v.353h1.138l-.147.395h-.985c.037.583.267.874.692.874.185 0 .332-.049.44-.147a.498.498 0 0 0 .157-.343Z",
    fill: "#001E62"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.133,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E6F9FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.704 15.725h-.672v-1.952h.64c.512 0 .912-.17 1.2-.512.224-.267.336-.581.336-.944 0-.395-.133-.726-.4-.992-.256-.256-.587-.384-.992-.384-.501 0-.885.192-1.152.576-.192.277-.299.619-.32 1.024h-2.032c.032-1.099.379-1.957 1.04-2.576.63-.587 1.461-.88 2.496-.88 1.163 0 2.048.357 2.656 1.072.48.565.72 1.264.72 2.096 0 1.162-.523 2-1.568 2.512 1.237.522 1.856 1.461 1.856 2.816 0 1.205-.405 2.16-1.216 2.864-.704.597-1.584.896-2.64.896-1.216 0-2.17-.4-2.864-1.2-.555-.65-.87-1.461-.944-2.432h2.048c.17 1.141.763 1.712 1.776 1.712.619 0 1.093-.208 1.424-.624.267-.32.4-.71.4-1.168 0-.544-.176-1.003-.528-1.376-.33-.352-.752-.528-1.264-.528Z",
    fill: "#2F7B84"
  })));
};
var RedeemIcon = SvgRedeeminline;

export { RedeemIcon as default };
//# sourceMappingURL=redeem.inline.svg.js.map
